<template>
  <v-container class="pa-0">
    <v-dialog v-model="dialog" persistent max-width="420px">
      <v-card>
        <v-card-title class="py-6">Xác nhận sửa</v-card-title>
        <v-card-text style="color: black">
          Thao tác này sẽ sửa <strong>{{ this.type | getType }}</strong> của học sinh. Xác nhận sửa?
        </v-card-text>
        <v-card-actions class="px-6 pb-6 pt-0">
          <v-btn color="blue darken-4" text @click="close" outlined>Hủy</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-4" class="white--text elevation-0" @click="openConfirm">Xác nhận</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog for "in" -->
    <v-dialog v-model="messageIn" persistent max-width="420px">
      <v-card>
        <v-card-title class="py-6">Xác nhận sửa</v-card-title>
        <v-card-text style="color: black">
          Bạn có muốn gửi thông báo cho phụ huynh về sự thay đổi của thời gian <strong>đến trường</strong> của học sinh
          không?
        </v-card-text>
        <v-card-actions class="px-6 pb-6 pt-0">
          <v-btn color="blue darken-4" text outlined @click="handleResponse('in', false)">Không</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-4" class="white--text elevation-0" @click="handleResponse('in', true)">Có</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog for "out" -->
    <v-dialog v-model="messageOut" persistent max-width="420px">
      <v-card>
        <v-card-title class="py-6">Xác nhận sửa</v-card-title>
        <v-card-text style="color: black">
          Bạn có muốn gửi thông báo cho phụ huynh về sự thay đổi của thời gian <strong>rời trường</strong> của học sinh
          không?
        </v-card-text>
        <v-card-actions class="px-6 pb-6 pt-0">
          <v-btn color="blue darken-4" text outlined @click="handleResponse('out', false)">Không</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-4" class="white--text elevation-0" @click="handleResponse('out', true)">Có</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      messageIn: false,
      messageOut: false,
      inConfirmed: false,
      outConfirmed: false,
    }
  },
  props: {
    state: Boolean,
    type: String,
  },
  watch: {
    state(val) {
      if (val) {
        this.dialog = true
      }
    },
    dialog(val) {
      if (!val) {
        this.resetConfirmations()
      }
    },
  },
  methods: {
    close() {
      this.dialog = false
    },
    openConfirm() {
      this.dialog = false
      if (this.type === 'in') {
        this.messageIn = true
      } else if (this.type === 'out') {
        this.messageOut = true
      } else if (this.type === 'both') {
        this.messageIn = true
      }
    },
    handleResponse(type, response) {
      if (type === 'in') {
        this.inConfirmed = response
        this.messageIn = false
        if (this.type === 'both') {
          this.messageOut = true
        } else {
          this.finalizeConfirm()
        }
      } else if (type === 'out') {
        this.outConfirmed = response
        this.messageOut = false
        this.finalizeConfirm()
      }
    },
    finalizeConfirm() {
      const send = this.inConfirmed || this.outConfirmed
      const finalType =
        this.inConfirmed && this.outConfirmed ? 'both' : this.inConfirmed ? 'in' : this.outConfirmed ? 'out' : ''
      this.$emit('confirm', { type: finalType, send })
      this.close()
      this.resetConfirmations()
    },
    resetConfirmations() {
      this.inConfirmed = false
      this.outConfirmed = false
    },
  },
  filters: {
    getType(type) {
      switch (type) {
        case 'in':
          return 'giờ đến'
        case 'out':
          return 'giờ về'
        case 'both':
          return 'giờ đến và giờ về'
        default:
          return '--'
      }
    },
  },
}
</script>

<style></style>
